import React from "react";
import { motion } from "framer-motion";
import { resolveSiteName, SITE_DOMAIN } from "../../utils/siteConfig";
import { useLocalContext } from "../../context/LocalContext";
import "./About.css";

const About = () => {
  const { webinfo = {} } = useLocalContext();
  const brand = resolveSiteName(webinfo);

  return (
    <section className="ab">
      <div className="ab__hero">
        <div className="ab__heroWrap">
          <motion.div initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
            <p className="ab__kicker">About {brand}</p>
            <h1 className="ab__title">
              Setup help that feels calm — even when the device doesn’t.
            </h1>
            <p className="ab__lead">
              {brand} exists for the moment a printer won’t connect or an extender won’t pair.
              We combine brand-specific guided flows with live specialists so you can finish the job.
            </p>
            <div className="ab__heroCtas">
              <a className="ab__btn ab__btn--primary" href="/printlab">
                Start printer setup
              </a>
              <a className="ab__btn ab__btn--ghost" href="/contact">
                Contact us
              </a>
            </div>
          </motion.div>
        </div>
      </div>

      <div className="ab__section">
        <div className="ab__wrap">
          <h2>What we stand for</h2>
          <div className="ab__values">
            <article>
              <h3>Clarity first</h3>
              <p>One clear next step at a time — not a manual you’ll abandon halfway.</p>
            </article>
            <article>
              <h3>Brand awareness</h3>
              <p>HP, Canon, Epson, Brother, Netgear, TP‑Link, Linksys, D‑Link — paths that match the device.</p>
            </article>
            <article>
              <h3>Human when it matters</h3>
              <p>When firmware or pairing loops hit, a specialist stays with you until it works.</p>
            </article>
          </div>
        </div>
      </div>

      <div className="ab__section ab__section--mist">
        <div className="ab__wrap ab__ctaBand">
          <div>
            <h2>Ready when you are</h2>
            <p>
              Visit {SITE_DOMAIN} anytime to start a guided setup, or reach out if you’d rather talk it through.
            </p>
          </div>
          <a className="ab__btn ab__btn--primary" href="/wavelab">
            Wi‑Fi extender help
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
